import { Monitor, Moon, Sun, type LucideIcon } from "lucide-react";

import type { Theme } from "@/components/admin/theme-context";

/**
 * The one theme setting of the app (ra-core store key `theme`, read and
 * written through useTheme): the desktop sidebar control cycles through it
 * and the account settings pick from it, with the same labels and icons.
 */
export const THEME_OPTIONS: readonly {
  value: Theme;
  labelKey: string;
  icon: LucideIcon;
}[] = [
  { value: "light", labelKey: "crm.theme.light", icon: Sun },
  { value: "dark", labelKey: "crm.theme.dark", icon: Moon },
  { value: "system", labelKey: "crm.theme.system", icon: Monitor },
];

const optionOf = (theme: Theme) =>
  THEME_OPTIONS.find((option) => option.value === theme) ??
  THEME_OPTIONS[THEME_OPTIONS.length - 1];

/** Light → dark → system → light. */
export const nextTheme = (theme: Theme): Theme => {
  const index = THEME_OPTIONS.indexOf(optionOf(theme));
  return THEME_OPTIONS[(index + 1) % THEME_OPTIONS.length].value;
};

export const themeOption = optionOf;
